/** Default country code when i18nUtils is not available (US) */
export const DEFAULT_COUNTRY_CODE = '1';

/** Max length for US/Canada numbers - used as default for supported locales */
export const PHONE_NUMBER_MAX_LENGTH = 15;

/**
 * Max digits for national number by country calling code.
 * Used when i18nUtils doesn't provide formatting (unsupported locale).
 */
export const PHONE_MAX_DIGITS_BY_COUNTRY: Record<string, number> = {
  '1': 10,
  '33': 9,
  '34': 9,
  '44': 11,
  '52': 10,
  '55': 11,
  '56': 9,
  '86': 11,
  '91': 11,
  '353': 9,
};
